import React from 'react';
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';

const ErrorMessage = ({ message }) => {
  return (
    <div className="flex items-center p-4 text-sm text-red-800 bg-red-50 border border-red-200 rounded-lg dark:bg-red-900/20 dark:text-red-400 dark:border-red-800">
      <ExclamationTriangleIcon className="w-5 h-5 mr-3 flex-shrink-0" />
      <span>{message}</span>
    </div>
  );
};

export default ErrorMessage;